import { socialLogin, socialSignup } from "@/social/index.js";

const apple = {
  init() {
    window.APPLE = AppleID.auth.init({
      clientId: process.env.VUE_APP_SOCIAL_APPLE_CLIENT_ID,
      scope: "email",
      redirectURI: "https://member.thegolf.com/login", //  개발용 주소
      state: process.env.VUE_APP_SOCIAL_APPLE_CLIENT_ID,
    });
  },

  async login(appleUser, callback) {
    if (!appleUser || !appleUser.userData) {
      this.LoginFailure();
      return;
    }

    const req = {
      id: appleUser.userData.sub,
      name: false,
      email: appleUser.userData.email,
      social: "apple",
    };

    const [flag, data] = await socialLogin(req);

    if (typeof callback === "function") {
      callback(req, flag, data);
    }
  },

  async signup(appleUser, callback) {
    const req = {
      id: appleUser.userData.sub,
      name: false,
      email: appleUser.userData.email,
      social: "apple",
    };

    const [flag, data] = await socialSignup(req);

    if (typeof callback === "function") {
      callback(req, flag, data);
    }
  },

  LoginFailure() {
    alert("애플 로그인에 실패했습니다.");
    return false;
  },
};

export default apple;
